import { useEffect, useState } from "react";
import { SearchBox } from "../../../../style/popup";
import {
  SearchMemberButtonWrapper,
  SearchMemberHeader,
  SearchMemberListWrapper,
  SearchMemberPopupWrapper,
} from "./style";
import {
  PubMemberDto,
  getTournamentMember,
} from "../../../../../../api/member";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../../../../recoil/pub.atom";
import { Overlay } from "../../../../../../styles/popup";

export interface SearchMemberProps {
  prizeList: any[];
  setPrizeList: any;
  index: number;
  onClose: () => void;
  tournamentId: number;
}
const SearchMemberPopup = ({
  prizeList,
  setPrizeList,
  index,
  onClose,
  tournamentId,
}: SearchMemberProps) => {
  const [member, setMember] = useState<PubMemberDto | null>(null);
  const [searchNick, setSearchNick] = useState<string>("");
  const [memberList, setMemberList] = useState<PubMemberDto[]>([]);
  const pub = useRecoilValue(pubState);

  const getData = async () => {
    if (!pub) return;
    try {
      const res = await getTournamentMember(tournamentId);
      const list = res.memberList;

      const filteredList = list.filter((item) =>
        item.nickname.toLowerCase().includes(searchNick.toLowerCase()),
      );

      setMemberList(() => {
        return [
          ...filteredList.filter((item) => {
            return !prizeList.some(
              (member) => member.nickname === item.nickname,
            );
          }),
        ];
      });
    } catch (error: any) {
      alert(error.message);
      return;
    }
  };

  useEffect(() => {
    getData();
  }, [searchNick]);

  const selectMember = (member: PubMemberDto | null) => {
    if (!member) return;
    setMember(member);
  };

  const selectMemberToSearch = () => {
    if (!member || !pub) return;

    const newPrizeList = prizeList.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          memberId: member.memberId,
          nickname: member.nickname,
        };
      }
      return { ...item };
    });
    setPrizeList(newPrizeList);
    localStorage.setItem(
      `tournament_${tournamentId}`,
      JSON.stringify(newPrizeList),
    );
    onClose();
  };

  return (
    <>
      <Overlay $zIndex={1000} />
      <SearchMemberPopupWrapper>
        <SearchMemberHeader>
          <div className="title">회원 찾기</div>
          <SearchBox>
            {member && <span className="member">{member.nickname}</span>}
            <input
              type="text"
              placeholder={!member ? "닉네임을 검색하세요. " : ""}
              value={searchNick}
              onKeyUp={(e) => {
                if (e.key === "Enter") {
                  getData();
                }
              }}
              onChange={(e) => setSearchNick(e.target.value)}
            />
            <div className="searchIcon" onClick={() => getData()}>
              <img
                src="/image-web/timer-config/searchIcon.svg"
                alt="검색 아이콘"
              />
            </div>
          </SearchBox>
        </SearchMemberHeader>
        <SearchMemberListWrapper>
          {memberList?.map((item: PubMemberDto) => (
            <div className="member" onClick={() => selectMember(item)}>
              {item?.nickname}
            </div>
          ))}
        </SearchMemberListWrapper>
        <SearchMemberButtonWrapper>
          <div className="button purple" onClick={selectMemberToSearch}>
            저장
          </div>
          <div className="button" onClick={onClose}>
            취소
          </div>
        </SearchMemberButtonWrapper>
      </SearchMemberPopupWrapper>
    </>
  );
};

export default SearchMemberPopup;
